import { z } from 'zod';

/** `sender_phone` is varchar(32) and holds `'+' + wa_id`. */
export const WHATSAPP_WA_ID_MAX_LENGTH = 31;

export const WHATSAPP_UNMATCHED_REASONS = ['NO_MATCH', 'AMBIGUOUS'] as const;
export const WhatsAppUnmatchedReasonSchema = z.enum(WHATSAPP_UNMATCHED_REASONS);
export type WhatsAppUnmatchedReason = z.infer<typeof WhatsAppUnmatchedReasonSchema>;

// IMM-928 ships no customer send/receive side, so nothing constructs a message
// against a CONTACT or LEAD subject today; the type is kept two-valued (not
// reduced to a single case) because the dispatch row shape carries it and a
// future caller (IMM-1040) is expected to add its own subject kind here.
export const WHATSAPP_SUBJECT_TYPES = ['CONTACT', 'LEAD'] as const;
export const WhatsAppSubjectTypeSchema = z.enum(WHATSAPP_SUBJECT_TYPES);
export type WhatsAppSubjectType = z.infer<typeof WhatsAppSubjectTypeSchema>;

export const WHATSAPP_DELIVERY_STATES = ['SENDING', 'DELIVERED', 'FAILED'] as const;
export const WhatsAppDeliveryStateSchema = z.enum(WHATSAPP_DELIVERY_STATES);
export type WhatsAppDeliveryState = z.infer<typeof WhatsAppDeliveryStateSchema>;

/** The vendor-neutral reasons the UX renders. Meta's numeric code never reaches the operator app. */
export const WHATSAPP_FAILURE_REASONS = ['WINDOW_CLOSED', 'NOT_ON_WHATSAPP', 'UNSUPPORTED_CONTENT', 'UNKNOWN'] as const;
export const WhatsAppFailureReasonSchema = z.enum(WHATSAPP_FAILURE_REASONS);
export type WhatsAppFailureReason = z.infer<typeof WhatsAppFailureReasonSchema>;
